const rulesDummyData: any[] = [
  {
    id: 1,
    rule_name: 'rule 1',
    rule_version: 'v2.0',
    rule_type: 'type1',
    rule_start_date: '1st Jan 2024',
    rule_end_date: '31st March 2024',
    is_active: true,
  },
  {
    id: 2,
    rule_name: 'rule 2',
    rule_version: 'v2.0',
    rule_type: 'type1',
    rule_start_date: '1st Jan 2024',
    rule_end_date: '31st March 2024',
    is_active: false,
  },
  {
    id: 1,
    rule_name: 'rule 3',
    rule_version: 'v2.0',
    rule_type: 'type1',
    rule_start_date: '1st Jan 2024',
    rule_end_date: '31st March 2024',
    is_active: true,
  },
  {
    id: 1,
    rule_name: 'rule 4',
    rule_version: 'v2.0',
    rule_type: 'type1',
    rule_start_date: '1st Jan 2024',
    rule_end_date: '31st March 2024',
    is_active: true,
  },
  {
    id: 1,
    rule_name: 'rule 5',
    rule_version: 'v2.0',
    rule_type: 'type1',
    rule_start_date: '1st Jan 2024',
    rule_end_date: '31st March 2024',
    is_active: true,
  },
  {
    id: 1,
    rule_name: 'rule 6',
    rule_version: 'v2.0',
    rule_type: 'type1',
    rule_start_date: '1st Jan 2024',
    rule_end_date: '31st March 2024',
    is_active: true,
  },
  {
    id: 1,
    rule_name: 'rule 7',
    rule_version: 'v2.0',
    rule_type: 'type1',
    rule_start_date: '1st Jan 2024',
    rule_end_date: '31st March 2024',
    is_active: true,
  },
  {
    id: 1,
    rule_name: 'rule 8',
    rule_version: 'v2.0',
    rule_type: 'type1',
    rule_start_date: '1st Jan 2024',
    rule_end_date: '31st March 2024',
    is_active: true,
  },
  {
    id: 1,
    rule_name: 'rule 9',
    rule_version: 'v2.0',
    rule_type: 'type1',
    rule_start_date: '1st Jan 2024',
    rule_end_date: '31st March 2024',
    is_active: true,
  },
];
export default rulesDummyData;

// const rulesDropdown: any[] = [
//   {
//     label: 'Rule  1',
//     value: 'rule_1',
//   },
//   {
//     label: 'Rule  2',
//     value: 'rule_2',
//   },
//   {
//     label: 'Rule  3',
//     value: 'rule_3',
//   },
//   {
//     label: 'Rule  4',
//     value: 'rule_4',
//   },
//   {
//     label: 'Get Plan',
//     value: 'get_plan',
//   },
// ];

// Remove drp and key grid only
// const fileType: any[] = [
//   // {
//   //   label: 'Excel',
//   //   value: 'excel',
//   // },
//   {
//     label: 'Rule Grid',
//     value: 'dmn',
//   },
//   {
//     label: 'Python',
//     value: 'python',
//   },
//   {
//     label: 'Javascript',
//     value: 'javascript',
//   },
// ];
// const ruleType: any[] = [
//   {
//     label: 'Payout',
//     value: 'payout',
//   },
//   {
//     label: 'Capping',
//     value: 'capping',
//   },
//   {
//     label: 'Penalty',
//     value: 'penalty',
//   },
//   {
//     label: 'Clawback',
//     value: 'clawback',
//   },
//   {
//     label: 'Booster  Contest',
//     value: 'booster_contest',
//   },
// ];
// const adjustmentLevel = [
//   {
//     label: 'Transaction',
//     value: 'transaction',
//   },
//   {
//     label: 'Group',
//     value: 'group',
//   },
// ];
// const editorOptions: any = [
//   {
//     value: 'textarea',
//     label: 'Textarea',
//   },
//   {
//     label: 'Wizard',
//     value: 'wizard',
//   },
// ];
// const modeOptions: any = [
//   {
//     value: 'single',
//     label: 'Single',
//   },
//   {
//     label: 'Multiple',
//     value: 'sql',
//   },
// ];

const initialValues = {
  rule_is_active: true,
  rule_output_config: [
    {
      output: null,
      value: null,
      isSelected: false,
    },
  ],
  clawback_type: null,
  rule_expression: '',
  output_formula_editor_type: 'wizard',
  rule_applicability_editor_type: 'wizard',
  rule_applicability_mode_type: 'single',
  output_formula_mode_type: 'single',
  output_formula_type: 'simple',
  output_formula: {
    type: 'percentage',
  },
  file_upload_type: 'new_dmn',
  reporting_payout_variable_type: 'number',
  rule_file_type: 'dmn',
  enter_amount: '',
};

const initialValuesQueryBuilder = {
  caseList: [],
  elseType: '',
  elseValue: '',
};

// const uploadOptions: any = [
//   {
//     label: 'Upload A Rule File',
//     value: 'upload_file',
//   },
//   {
//     label: 'Create New Rule',
//     value: 'new_dmn',
//   },
// ];
// const dataType: any = [
//   {
//     label: 'String',
//     value: 'string',
//   },
//   {
//     label: 'Number',
//     value: 'number',
//   },
//   {
//     label: 'Date',
//     value: 'date',
//   },
// ];
export { initialValues, initialValuesQueryBuilder };
